import { makeApolloClient, logError } from '../util';
import { AGENDA, AGENDA_ITEM } from 'queries/agenda';
export const FETCH_AGENDA = 'FETCH_AGENDA';
export const FETCH_AGENDA_ITEM = 'FETCH_AGENDA_ITEM';
export const CLEAR_AGENDA = 'CLEAR_AGENDA';
export const CLEAR_AGENDA_ITEM = 'CLEAR_AGENDA_ITEM';
export const UPDATE_AGENDA_ITEM = 'UPDATE_AGENDA_ITEM';
export const CREATE_AGENDA_ITEM = 'CREATE_AGENDA_ITEM';
export const DELETE_AGENDA_ITEM = 'DELETE_AGENDA_ITEM';
export const ADD_GROUPS_TO_AGENDA_ITEM = 'ADD_GROUPS_TO_AGENDA_ITEM';
export const REMOVE_GROUPS_FROM_AGENDA_ITEM = 'REMOVE_GROUPS_FROM_AGENDA_ITEM';
export const ADD_MATERIAL_TO_AGENDA_ITEM = 'ADD_MATERIAL_TO_AGENDA_ITEM';
export const DELETE_MATERIAL_FROM_AGENDA_ITEM = 'DELETE_MATERIAL_FROM_AGENDA_ITEM';
export const UPDATE_MATERIAL = 'UPDATE_MATERIAL';
export const ADD_GROUPS_TO_MATERIAL = 'ADD_GROUPS_TO_MATERIAL';
export const REMOVE_GROUPS_FROM_MATERIAL = 'REMOVE_GROUPS_FROM_MATERIAL';
export const UPDATE_SELECTED_PERSON_OR_TRACK = 'UPDATE_SELECTED_PERSON_OR_TRACK';
export const UPDATE_SELECTED_VIEW = 'UPDATE_SELECTED_VIEW';
export const UPDATE_SELECTED_PERSON_OR_TRACK_NAME = 'UPDATE_SELECTED_PERSON_OR_TRACK_NAME';
export const CLEAR_AGENDA_FILTER_AND_SCROLL = 'CLEAR_AGENDA_FILTER_AND_SCROLL';
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

export const fetchAgenda = (agenda, from) => ({
	type: FETCH_AGENDA,
	agenda,
	from,
});

export const clearAgenda = from => ({
	type: CLEAR_AGENDA,
	from,
});

const fetchAgendaItem = (agendaItem, from) => ({
	type: FETCH_AGENDA_ITEM,
	agendaItem,
	from,
});

export const clearAgendaItem = from => ({
	type: CLEAR_AGENDA_ITEM,
	from,
});

export const updateAgendaItem = (agendaItem, from) => ({
	type: UPDATE_AGENDA_ITEM,
	from,
	agendaItem,
});

export const createAgendaItem = (agendaItem, from) => ({
	type: CREATE_AGENDA_ITEM,
	from,
	agendaItem,
});

export const deleteAgendaItem = ({ id }, from) => ({
	type: DELETE_AGENDA_ITEM,
	from,
	agendaItemID: id,
});

export const addGroupsToAgendaItem = (groupIDs, agendaItemID, from) => ({
	type: ADD_GROUPS_TO_AGENDA_ITEM,
	from,
	groupIDs,
	agendaItemID,
});

export const removeGroupsFromAgendaItem = (groupIDs, agendaItemID, from) => ({
	type: REMOVE_GROUPS_FROM_AGENDA_ITEM,
	from,
	groupIDs,
	agendaItemID,
});

export const addMaterialToAgendaItem = (materials, from) => ({
	type: ADD_MATERIAL_TO_AGENDA_ITEM,
	from,
	materials,
});

export const deleteMaterialFromAgendaItem = ({ id }, from) => ({
	type: DELETE_MATERIAL_FROM_AGENDA_ITEM,
	from,
	materialID: id,
});

export const updateMaterial = (material, from) => ({
	type: UPDATE_MATERIAL,
	from,
	material,
});

export const addGroupsToMaterial = (groupIDs, materialID, from) => ({
	type: ADD_GROUPS_TO_MATERIAL,
	from,
	groupIDs,
	materialID,
});

export const removeGroupsFromMaterial = (groupIDs, materialID, from) => ({
	type: REMOVE_GROUPS_FROM_MATERIAL,
	from,
	groupIDs,
	materialID,
});

export const updateSelectedPersonOrTrack = (selectedPersonOrTrack, from) => ({
	type: UPDATE_SELECTED_PERSON_OR_TRACK,
	from,
	selectedPersonOrTrack,
});

export const updateSelectedPeronOrTrackName = (selectedPersonOrTrackName, from) => ({
	type: UPDATE_SELECTED_PERSON_OR_TRACK_NAME,
	from,
	selectedPersonOrTrackName,
});

export const updateSelectedView = (selectedView, from) => ({
	type: UPDATE_SELECTED_VIEW,
	from,
	selectedView,
});

export const clearAgendaFilterAndScroll = from => ({
	type: CLEAR_AGENDA_FILTER_AND_SCROLL,
	from,
});

export const setScrollPosition = scrollPosition => ({
	type: SET_SCROLL_POSITION,
	scrollPosition,
});

export const thunkFetchAgenda = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { agenda } = await client.request(AGENDA, {
			event_id: eventID,
		});
		dispatch(fetchAgenda(agenda, from));
	} catch (error) {
		logError(error, 'agenda.actions.thunkFetchAgenda');
	}
};

export const thunkFetchAgendaItem = (agendaID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { agendaItem } = await client.request(AGENDA_ITEM, {
			id: agendaID,
		});
		dispatch(fetchAgendaItem(agendaItem, from));
	} catch (error) {
		logError(error, 'agenda.actions.thunkFetchAgendaItem');
	}
};
